import { useCallback, useEffect, useMemo, useState } from "react"
import TableHeader from "../Components/TableHeader"
import core from "../core";
import { Download } from "react-bootstrap-icons";
import TableLoader from "../Components/TableLoader";
import TableFoot from "../Components/TableFoot";
import ExportModal from "../Components/ExportModal";
import api from "../lib/api";
import useNotify from "../hooks/useNotify";
import useListData from "../hooks/useListData";
import useTableFilter from "../hooks/useTableFilter";
import useSortOptions from "../hooks/useSortOptions";

const LogsHistory = ({ setNotification }) => {
    const notify = useNotify(setNotification);
    const { filter, setFilter, clampPage } = useTableFilter({
        page: 1, limit: 10, keyword: "", sort_by: "id", sort_order: "DESC",
        auction: "", admin: "", start_date: "", end_date: "",
    });
    const [exportLoad, setExportLoad] = useState(false);
    const [exportLimit, setExportLimit] = useState({ modal: false, limit: "10" });

    const sortBy = useSortOptions("bids-sort-by", notify);
    const onListError = useCallback((err) => notify.error(err), [notify]);
    const { data: logsHistory, total, loading } = useListData("/bids", filter, { onError: onListError });

    const pageCount = useMemo(() => Math.max(1, Math.ceil(total / filter.limit)), [total, filter.limit]);
    useEffect(() => { clampPage(total); }, [total, clampPage]);

    function exportLogs() {
        setExportLoad(true);
        api.get('/export/bids', { params: { ...filter, limit: exportLimit.limit } })
            .then((res) => {
                // Root-relative. Prefixing with window.location.hostname (which
                // carries no scheme) produced a relative path that always 404'd.
                window.open(res.data.url, "_blank", "noopener");
                setExportLimit((prev) => ({ ...prev, modal: false }));
            })
            .catch((err) => notify.error(err, "Export failed."))
            .finally(() => setExportLoad(false));
    }

    return (
        <div className="page-content-container">
            <h2 className="page-title">Bids History</h2>
            <TableHeader
                setNotification={setNotification}
                exportHandler={() => setExportLimit((prev) => ({ ...prev, modal: true }))}
                exportLoad={exportLoad}
                filter={filter}
                withoutAddNew={true}
                AddNewButtonIcon={Download}
                sortBy={sortBy}
                exportButton={true}
                checkboxes={[]}
                setFilter={setFilter}
            />
            <div className="table-scroll">
                <table className="responsive-d-table">
                    <thead>
                        <tr>
                            <th>Lot</th>
                            <th>Username</th>
                            <th>Amount</th>
                            <th>Bidder</th>
                            <th>Date</th>
                            <th>IP Address</th>
                            <th>Auction</th>
                            <th>Action Type</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {/* The per-row checkbox column was removed: it was
                            unbound and nothing ever read a selection here. */}
                        {(!loading && logsHistory.length > 0) && logsHistory.map((logs, id) => (
                            <tr key={logs.id} className={(id + 2) % 2 === 0 ? "even-row" : "odd-row"}>
                                <td>{logs.lot}</td>
                                <td>{logs.username}</td>
                                <td>{logs.amount}</td>
                                <td>{logs.bidder}</td>
                                <td>{core.formdatDate(new Date(logs.action_date), "yyyy-mm-dd hr:min:sec")}</td>
                                <td>{logs.ip_address}</td>
                                <td>{logs.auction}</td>
                                <td>{logs.action_type}</td>
                                <td>{logs.status}</td>
                            </tr>
                        ))}
                        {(!loading && logsHistory.length === 0) && <tr className="empty-row">
                            <td colSpan={9}><div className="empty-records"><span>Records not found</span></div></td>
                        </tr>}
                        {loading && <TableLoader colspan={9} />}
                    </tbody>
                </table>
            </div>
            <TableFoot filter={filter} setFilter={setFilter} count={pageCount} total={total} />
            <ExportModal state={exportLimit} setState={setExportLimit} onExport={exportLogs} loading={exportLoad} />
        </div>
    )
}

export default LogsHistory
